/**
 * 预订人模块
 */
import React from 'react';
import intl from 'react-intl-universal';

import { renderContent } from '@/utils';
import { CERT_TYPE_MAP } from '@/config/constant';
import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { formatAreaMobileStr } from '@/components/BaseMobileInput/helper';
import { useDetailData } from '@/pages/reservation/reverseRollback/helper';

const Index = () => {
  const { name, certType, certNo, mobile, email, memberLevelMap, memberLevel } = useDetailData();

  return (
    <ContentBlock title={intl.get('reservation_booker_block_title')}>
      <FormItem label={intl.get('app_constants_booker_name')}>{name}</FormItem>
      <FormItem label={intl.get('app_reservation_cert_type')}>
        {renderContent(CERT_TYPE_MAP[certType])}
      </FormItem>
      <FormItem label={intl.get('app_reservation_cert_number')}>{renderContent(certNo)}</FormItem>
      <br />
      <FormItem label={intl.get('app_reservation_phone_number')}>
        {formatAreaMobileStr(mobile)}
      </FormItem>
      <FormItem label={intl.get('help_store_address_type_email')}>{renderContent(email)}</FormItem>
      <FormItem label={intl.get('app_reservation_member_level')}>
        {renderContent(memberLevelMap[memberLevel])}
      </FormItem>
    </ContentBlock>
  );
};

export default Index;
